const locale = {
  placeholder: 'Select time',
  rangePlaceholder: ['Start time', 'End time']
};
var TimePicker = locale;
export { TimePicker as default };
//# sourceMappingURL=en_US.js.map
